import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ChartCard = ({
  icon,
  iconColor = "",
  title,
  badge,
  actions,
  summary,
  children,
  className = "",
}) => (
  <div className={`chart-card ${className}`}>
    <div className="chart-card-header">
      {icon && (
        <div className={`chart-card-icon ${iconColor}`}>
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
      <h5 className="chart-card-title">{title}</h5>
      {badge && <span className="chart-card-badge">{badge}</span>}
      {actions}
    </div>
    <div className="chart-card-content">{children}</div>
    {summary && summary.length > 0 && (
      <div className="chart-summary">
        {summary.map((s) => (
          <div key={s.label} className="summary-item">
            <span className="summary-label">{s.label}</span>
            <span className="summary-value">{s.value}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default ChartCard;
